import { render, staticRenderFns } from "./ThreeStars.vue?vue&type=template&id=72b439a7&scoped=true&"
import script from "./ThreeStars.vue?vue&type=script&lang=js&"
export * from "./ThreeStars.vue?vue&type=script&lang=js&"
import style0 from "./ThreeStars.vue?vue&type=style&index=0&id=72b439a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b439a7",
  null
  
)

export default component.exports